import React from "react";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import Chip from "@mui/material/Chip";
import { PermitType } from "common/types/permits";
import { formatRenewalPeriod } from "../types";

export interface PermitInfoSectionProps {
  authorityName: string;
  permitType: PermitType;
}

export const PermitInfoSection: React.FC<PermitInfoSectionProps> = ({ authorityName, permitType }) => {
  const zoneCoverageLabel =
    permitType.zoneCoverageType === "jurisdiction_wide" ? "Jurisdiction-wide" : "Zone-specific coverage";

  return (
    <Card variant="outlined">
      <CardContent>
        <Typography variant="h6" component="h3" gutterBottom>
          Permit Information
        </Typography>

        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          <Box>
            <Typography variant="body2" color="text.secondary">
              Permit Type
            </Typography>
            <Typography variant="body1" fontWeight={500}>
              {permitType.name}
            </Typography>
          </Box>

          <Box>
            <Typography variant="body2" color="text.secondary">
              Authority
            </Typography>
            <Typography variant="body1">{authorityName}</Typography>
          </Box>

          <Box>
            <Typography variant="body2" color="text.secondary">
              Description
            </Typography>
            <Typography variant="body1">{permitType.description}</Typography>
          </Box>

          <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
            <Chip label={zoneCoverageLabel} size="small" variant="outlined" />
            <Chip label={`Renews ${formatRenewalPeriod(permitType.renewalPeriod)}`} size="small" variant="outlined" />
            {permitType.vehicleScope === "per_account" && (
              <Chip label="Account-wide" size="small" variant="outlined" color="primary" />
            )}
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
};

export default PermitInfoSection;
